const ProjectsData = [
    {
        'id': 1,
        'name': 'Bridgenet Computer',
        'ui': 'https://i.ibb.co/d5QGxpZ/bridgenet-computer-web-app1.png',
        'description': 'A Complete Responsive Service Providing Website, Where you can book a service using credit card',
        'github': 'https://github.com/NaimulAlam/BridgenetComputer-Client',
        'web': 'https://bridgenet-computer.web.app/',
    },
    {
        'id': 2,
        'name': 'Cyberpunk Laptop',
        'ui': 'https://i.ibb.co/M2dbZ1B/cyberpunk-laptop-web-app.png',
        'description': 'Cyberpunk Laptop is a E-Commerce full stack web app where you can buy gaming laptops',
        'github': 'https://github.com/NaimulAlam/Cyberpunk-Laptop-Client',
        'web': 'https://cyberpunk-laptop.web.app/',
    },
    {
        'id': 3,
        'name': 'Chattagram Metro Rail',
        'ui': 'https://i.ibb.co/pLqBgLR/chattagram-metro-rail-web-app.png',
        'description': 'A Complete Responsive Ticket Purchasing Website, Where you can book a your ticket and see the destination on google map',
        'github': 'https://github.com/NaimulAlam/Chattagram-Metro',
        'web': 'https://i.ibb.co/pLqBgLR/chattagram-metro-rail-web-app.png',
    },
    {
        'id': 4,
        'name': 'Wonder 11',
        'ui': 'https://i.ibb.co/ngQsmzc/wonder-11-netlify-app.png',
        'description': 'Wonder 11 is Football Team player purchasing web app where you can select players and see their market values',
        'github': 'https://github.com/NaimulAlam/Wonder11',
        'web': 'https://wonder-11.netlify.app/wonder11',
    },
];

export default ProjectsData;